import React from 'react'
import { Widget } from '@typeform/embed-react'
import { Container, Row } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { signout } from '../../redux/actions/userActions'
import '../../scss/component/assessments/assessment.scss';
class AssessmentForms extends React.Component {
  render () {
    let url = this.props.url;
    url = url.replace("https://postured.typeform.com/to/","");
    let formID = this.props.url.split('/')[4];
    const tenantid = localStorage.getItem('tenant')
		const sessionObject = JSON.parse(localStorage.getItem('pos-session'))
		const firstName = sessionObject.attributes.given_name;
		const lastName = sessionObject.attributes.family_name;
		const fullname = firstName + " " + lastName;

    return (
      <Container
        className={`typeform-container ${this.props.i === this.props.categoryIndex ? 'display' : 'invisible'}`}
        key={uuid()}>
        <Row>
          <Widget 
            id={formID} 
            className="box"
            hidden={{
              tenantid: tenantid,
              fullname: fullname,
              email: this.props.email,
              frameworkname: this.props.frameworkName,
              month: this.props.month
            }}
          />
        </Row>
      </Container>
    )
  }
}
export default connect(null, { signout })(withRouter(AssessmentForms))



// WEBPACK FOOTER //
// ./src/components/training/TypeformView.js